import React, {useEffect, useState} from "react";
import {DropdownItem} from "utils/general-models";
import {Dropdown, DropdownChangeParams} from "primereact/dropdown";
import {useGetProductTemplateInfos} from "api/api-hooks/product-templates-hooks";

export interface IProductTemplateDropdownChangeParams {
    value: number,
    refName: string,
}

interface IProductTemplateDropdownProps {
    // Product template ID
    value?: number | null;
    onChange?: (e: IProductTemplateDropdownChangeParams) => void;
}

interface ProdTemplateDropdownItem extends DropdownItem<number> {
    refName: string;
}

export function ProductTemplateDropdown(props: IProductTemplateDropdownProps) {
    const [allSelections, setAllSelections] = useState<ProdTemplateDropdownItem[]>([]);

    const query = useGetProductTemplateInfos();

    useEffect(() => {
        if(query.data){
            const selections = query.data.map((it) => ({ value: it.id, label: it.displayName, refName: it.refName }));
            setAllSelections(selections);
        }
    }, [query.data])

    const onChange = (e: DropdownChangeParams) => {
        const refName = allSelections.find((it) => it.value === e.value)?.refName;
        props.onChange?.({value: e.value, refName: refName!!});
    }

    return <>
        { query.error &&
            <span>Product template selection error!</span>
        }

        { query.isLoading && !query.error &&
            <span>Product templates loading...</span>
        }

        { query.isSuccess &&
            <Dropdown placeholder="Select Product Template"
                      value={props.value || null}
                      options={allSelections}
                      filter={true}
                      filterMatchMode="contains"
                      onChange={onChange}
            />
        }
    </>
}